import React  from 'react';
import {Header, Image, List, Label, Table, Icon,  Rail, Ref, Sticky, Rating, Breadcrumb, Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Content from '../NetflixSlider/ContentHeader'
import '../../App.css'; 
import Objetivo from './Objetivo';
import Modulos from './Modulos';
import Instructores from './Instructores';
import _ from 'lodash' ;
import Slider from '../NetflixSlider'; 
import PricingTable from "./PricingTable";
import Resena from "./Resena";

 

const Curso=({ id, contextRef, curso, modulos, instructores=[], cursos, onAcordionModulo, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, opinion, cursoPago, user, onInscribir, onChangeCupon, cupon, cuponValido, onShowModalInstructor})=>{

    let margenes={marginTop: '1em', marginLeft: '0%',  minHeight:'88vh', marginRight: '0%'};   
	let margenesContenido={marginTop: '1em', marginLeft: '3%',   marginRight: '3%'};   
	
    return (
        <div className="app">
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous" />
            
            <Grid>
                <Grid.Row only='computer tablet'>
                    <Grid.Column>
                        <Content  movie={curso}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row only='mobile'>
                    <Grid.Column>
                        <p>    
                            <h1>{curso.title}</h1>
                        </p>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        
            <Segment basic style={margenes}>
        
              
            <Grid  columns={2} divided>
                <Grid.Row only='computer tablet'>
                    <Grid.Column width="12">
                        <Ref innerRef={contextRef}>
                        <Segment basic>

                            <Objetivo
                                titulo="Loqueaprenderas"
                                strings={strings} 
                                margenes={margenesContenido} 
                                curso={curso}/>

                            <Modulos 
                                strings={strings} 
                                modulos={curso.modulos}
                                onAcordionModulo={onAcordionModulo}
                                margenes={margenesContenido}/>  

                            <Resena 
                                     strings={strings}   
                                    margenes={margenesContenido}
                                    opinion={opinion}/>
        
                             <Instructores 
                                 strings={strings}   
                                instructores={instructores}
                                margenes={margenes}
                                modalInstructor={onShowModalInstructor}
                                />        
                

                            {cursos!=null && cursos.length>0? 
                                <div>
                                    <Header as='h2' dividing>
                                       {strings?strings["CursosRelacionados"]:""}
                                    </Header>
                                    <div className="app" style={{backgroundColor: '#000000'}}> 

                                        <Slider>
                                            {cursos.map(movie => (
                                                <Slider.Item movie={movie}   key={movie.id}>item1</Slider.Item>
                                            ))}
                                        </Slider>
                                    </div>
                                    <Divider hidden/>
                                </div>

                            :""}

                          <Rail  position='right'  >
                            <Sticky offset={80} context={contextRef}>   
                                <PricingTable
                                    curso={curso}
                                    cursoPago={cursoPago}
                                    user={user}
                                    onInscribir={onInscribir}    
                                    strings={strings} 
                                    onChange={onChangeCupon}
                                    cupon={cupon}
                                    cuponValido={cuponValido}
                                />
                            </Sticky>
                          </Rail>

                        </Segment>
                        </Ref>
                </Grid.Column>
            </Grid.Row>
                                
            <Grid.Row only='mobile'>
                <Grid.Column  width="16">

                    <Segment basic>


                    <Objetivo margenes={margenesContenido} curso={curso}/>

                    <Modulos modulos={curso.modulos}
                        onAcordionModulo={onAcordionModulo}
                        margenes={margenesContenido}/>  



                     <PricingTable
                            curso={curso}
                            cursoPago={cursoPago}
                            user={user}
                            onInscribir={onInscribir}    
                            strings={strings}
                            onChange={onChangeCupon}
                            cupon={cupon}
                            cuponValido={cuponValido}
                        />        

                    <Resena  strings={strings} margenes={margenesContenido}/>

                     
                    
                    <Instructores 
                        strings={strings}    
                        instructores={instructores}
                        modalInstructor={onShowModalInstructor}
                        margenes={margenes}
                        />  
                    
                    
                     

                    {cursos!=null && cursos.length>0? 
                        <div>
                            <Header as='h2' dividing>
                                {strings?strings["CursosRelacionados"]:""}
                            </Header>
                            <div className="app" style={{backgroundColor: '#000000'}}> 

                                <Slider>
                                    {cursos.map(movie => (
                                        <Slider.Item movie={movie}   key={movie.id}>item1</Slider.Item>
                                    ))}
                                </Slider>
                            </div>
                            <Divider hidden/>
                        </div>

                    :""}


                    </Segment>

                </Grid.Column>
            </Grid.Row>            
                    
                    
            </Grid>

       </Segment> 
                    
     
        <Segment inverted vertical style={{ margin: '5em 0em 0em', padding: '5em 0em' }}>
      <Container >
        <Grid divided inverted stackable>
          <Grid.Column width={1}>
            <Header inverted as='h4' content='' />
            <List link inverted>
              <List.Item>                
                <a target="_blank" href='https://www.facebook.com/QualityConsultingLatinoamerica/'>
                  <List.Icon name='facebook square' size="big" />
                  </a> 
                </List.Item>

              <List.Item>
                <a target="_blank" href='https://www.linkedin.com/company/quality-consulting-asesores'>
                  <List.Icon name='linkedin square' size="big" />
                  </a> 
                </List.Item>

                <List.Item>
                <a target="_blank" href='https://www.instagram.com/qualityacademics/?hl=es-la'>
                  <List.Icon name='instagram' size="big" />
                  </a> 
                </List.Item>


                <List.Item>
                <a target="_blank" href='https://www.youtube.com/c/QualityConsulting-QualityAcademics'>
                  <List.Icon name='youtube square' size="big" />
                  </a> 
                </List.Item>
                  
                <List.Item>
                <a target="_blank" href='https://twitter.com/Q_Academics/'>
                  <List.Icon name='twitter square' size="big" />
                  </a> 
                </List.Item>  



            </List>
          </Grid.Column>

<Grid.Column width={3}>
            <Header inverted as='h4' content={strings?strings["QuienesSomos"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Content>
                <List.Icon name='linkify' />
                <a target="_blank"  href='https://www.qsc.com.mx/'>Quality Consulting</a>
              </List.Content>
            </List.Item>
              
            </List>
          </Grid.Column>


          <Grid.Column width={2}>
            <Header inverted as='h4' content={strings?strings["Nuestrasherramientas"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/green-belt/'>Green Belt</a>
              </List.Content>
            </List.Item>

<List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/black-belt/'>Black Belt</a>
              </List.Content>
            </List.Item>

<List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/orange-belt/'>Orange Belt </a>
              </List.Content>
            </List.Item>

<List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/premium-belt/'>Red Belt</a>
              </List.Content>
            </List.Item>

           <List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/red-belt/'>Premium belt</a>
              </List.Content>
            </List.Item>
                
            <List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.one.green-belt.com.mx'>Green belt one</a>
              </List.Content>
            </List.Item>    
                
            <List.Item>   
                    <List.Content>    
                    <a target="_blank"  href={"/info/reconocimientoManual?id=31"}  target="_black">Constancia</a>
                    </List.Content>    
            
               </List.Item>      
                
                    
                    


            </List>
          </Grid.Column>
          
          

<Grid.Column width={3}>
            <Header inverted as='h4' content={strings?strings["QCC"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Icon name='marker' />
              <List.Content>Cra. 13 # 98-70 of.604 edificio OCHIC. Bogotá, Colombia</List.Content>
            </List.Item>


<List.Item>
              <List.Icon name='phone square' />
              <List.Content>{strings?strings["Telefonos"]:""}: (57)3162968728</List.Content>
            </List.Item>

<List.Item>
              <List.Icon name='mail' />
                 <List.Content> <a href='mailto:contacto@qsc.com.mx'>contacto@qsc.com.mx</a>
               </List.Content>
            </List.Item>
              
            </List>
          </Grid.Column>



<Grid.Column width={4}>
            <Header inverted as='h4' content={strings?strings["QCM"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Icon name='marker' />
              <List.Content>Calzada de la Viga 1750 int. 21, Colonia Héroes de Churubusco, Alcaldía Iztapalapa (Ciudad de México 01090)</List.Content>
            </List.Item>


<List.Item>
              <List.Icon name='phone square' />
              <List.Content>{strings?strings["Telefonos"]:""}: 0155 5705 9011 / 9012 / 9013 / 9014</List.Content>
            </List.Item>

<List.Item>
              <List.Icon name='mail' />
                 <List.Content> <a href='mailto:contacto@qsc.com.mx'>contacto@qsc.com.mx</a>
               </List.Content>
            </List.Item>
              
            </List>
          </Grid.Column>






        </Grid>

         
        
      </Container>
    </Segment>
                    
                    
        </div>
	);
};



export default Curso;